<template>
	<Modals
		:title="title"
		:display="display"
		@show="close"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content>
			<div class="ccls-detail-modal">
				<div class="results-toolbar results-toolbar--variant-one">
					<div class="results-toolbar__search">
						<Search
							variant="toggle-icons"
							:placeholder="placeholder"
							v-model.lazy="search"
							data-test="search"
						/>
					</div>
					<div class="results-toolbar__counter">
						<ResultCounter :counter="companiesLocationsCount" />
					</div>
				</div>
				<CCLsDetailModalList
					:cclsData="companiesLocationsObj"
					data-test="list"
				/>
				<Spinner
					:processor="{ loading: loading }"
					data-test="spinner"
				/>
				<NoResults
					v-if="!companiesLocationsObj"
					data-test="noResults"
				/>
			</div>
		</template>
		<template #modal-footer>
			<Button
				className="btn--primary"
				labelText="Close"
				:btnClick="close"
				data-testid="closeBtn"
			/>
		</template>
	</Modals>
</template>

<script>
import Button from '@/components/forms/button/button';
import CCLsDetailModalList from '@/sections/environment/CCLsDetailModal/ccls-details-modal-list.vue';
import Modals from '@/components/shells/modal/modals';
import Search from '@/components/forms/search/search';
import NoResults from '@/site-components/no-results/no-results';
import Spinner from '@/components/visual/spinner/spinner';
import { filterAndSortArray } from '@/utils/function';
import ResultCounter from '@/site-components/result-counter/result-counter';

export default {
	name: 'CCLSDetailsModal',
	components: {
		Button,
		CCLsDetailModalList,
		Modals,
		Search,
		Spinner,
		NoResults,
		ResultCounter
	},
	model: {
		prop: 'display',
		event: 'close'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		source: {
			type: Object,
			default: () => {}
		},
		renderSource: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: 'Search by company name/# or location name'
		},
		title: {
			type: String,
			default: 'CCLs'
		},
		apiCall: {
			type: Function,
			default: () => {}
		},
		successCustomerApi: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			privilegedUser: true,
			search: '',
			companiesLocationsObj: {},
			sourceData: {}
		};
	},
	computed: {
		companiesLocationsCount() {
			const companiesCount = this.companiesLocationsObj?.companies
				?.length;
			const locationsCount = this.companiesLocationsObj?.locations
				?.length;
			const totalResultCount = companiesCount + locationsCount;
			return totalResultCount;
		},
		companiesLocationsFromSource() {
			if (this.renderSource) {
				return this.sourceData;
			}
			return [];
		}
	},
	methods: {
		close() {
			this.companiesLocationsObj = {};
			this.sourceData = {};
			this.search = '';
			this.$emit('close', false);
		},
		filterCompaniesBySearch(val) {
			return filterAndSortArray(
				this.sourceData.companies.filter(x => x.text != null),
				{
					text: val.toLowerCase()
				},
				null
			);
		},
		filterLocationsBySearh(val) {
			return filterAndSortArray(
				this.sourceData.locations.filter(x => x.text != null),
				{
					text: val.toLowerCase()
				},
				null
			);
		},
		filterCompaniesOrLocationsBySearch(val) {
			let newVal = val.toLowerCase();
			if (!newVal) {
				this.companiesLocationsObj = {
					...this.companiesLocationsFromSource
				};
				return;
			}

			let resultCompanies = this.filterCompaniesBySearch(newVal);
			let resultLocations = this.filterLocationsBySearh(newVal);

			this.companiesLocationsObj = {
				companies: [...resultCompanies],
				locations: [...resultLocations]
			};
		},
		setcompaniesLocationsObj() {
			if (
				this.apiCall instanceof Function &&
				this.apiCall().companies?.length > 0
			) {
				this.sourceData = this.apiCall();
			} else {
				this.sourceData = this.source;
			}

			this.companiesLocationsObj = this.sourceData;
		}
	},
	watch: {
		display(val) {
			if (val) {
				this.setcompaniesLocationsObj();
			}
		},
		search: {
			deep: true,
			handler(val) {
				if (this.sourceData?.companies?.length > 0) {
					this.filterCompaniesOrLocationsBySearch(val);
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Zone Manager - CCLs details modal
    * Can use SCSS variables = TRUE
*/

::v-deep .modal {
	@include mq($from: md) {
		width: 390px;
	}
}

::v-deep .modal__body {
	overflow: initial;
}

::v-deep
	.results-toolbar.results-toolbar--variant-one
	.results-toolbar__search {
	@include mq($from: md) {
		width: 100%;
	}
}

.ccls-detail-modal {
	padding-bottom: $padding-md;
}
</style>
